<template>
    <div class="card">
        <div class="d-flex justify-content-between mt-4 align-items-center">
            <div>
                <div class="title ml-5">Employee Net Promoter Score</div>
            </div>
            <div class="d-flex justify-content-end mr-5">
                <filters class="filters" @filter="onChangeFilters" />
            </div>
        </div>
        <div class="d-flex justify-content-around align-items-center">
            <donut :title="report.enps" :chartData="donutGraphicData" />
            <bar :chartData="barGraphicData" :chartLabels="barGraphicLabels" />
        </div>
        <hr class="top" />
        <additional-information
            :totalAnswered="report.total_answered"
            :totalAnsweredPercent="report.total_answered_percent"
        />
        <hr class="bottom" />
        <b-row class="mb-5">
            <b-col cols="6" class="pl-5 pr-5">
                <teams-ranking :filters="filters" />
            </b-col>
            <b-col cols="6" class="pl-5 pr-5 dividing-line">
                <comments :filters="filters" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { getEnpsReport, getEnpsAvegare } from '../api'
import { Donut, Bar, Comments, TeamsRanking, Filters, AdditionalInformation } from './components'

export default {
    name: 'Report',
    components: {
        Filters,
        Donut,
        Bar,
        Comments,
        TeamsRanking,
        AdditionalInformation,
    },
    data() {
        return {
            report: {
                total: 0,
                total_answered: 0,
                total_answered_percent: 0,
                enps: 0,
                promoters_total: 0,
                promoters_percent: 0,
                neutral_total: 0,
                neutral_percent: 0,
                detractors_total: 0,
                detractors_percent: 0,
            },
            isLoadingRankingTeams: false,
            enps_average: 0,
            filters: {
                enpsResearches: [],
                departments: [],
            },
        }
    },
    mounted() {
        this.setQueryFilter()
        this.getReport()
    },
    watch: {
        filters() {
            this.getReport()
        },
    },
    methods: {
        setQueryFilter() {
            const researchId = parseInt(this.$route.query.researchId)
            if (researchId) {
                this.filters.enpsResearches.push(researchId)
            }
        },
        onChangeFilters(filters) {
            this.filters = filters
        },
        getReport() {
            getEnpsReport(this.params).then((data) => {
                this.report = this.formatAllValuesInObject(data)
            })
        },
        getEnpsAvegare() {
            getEnpsAvegare().then((data) => {
                this.enps_average = parseFloat(data['enps'])
            })
        },
        formatAllValuesInObject(data) {
            const graphData = ['promoters_percent', 'neutral_percent', 'detractors_percent']
            return Object.keys(data).reduce((object, key) => {
                const parsedValue = graphData.includes(key) ? this.formatNumber(data[key]) : parseInt(data[key])
                object[key] = isNaN(parsedValue) ? 0 : parsedValue
                object[key] == false ? 0 : parsedValue
                return object
            }, {})
        },
        formatNumber(number) {
            return parseFloat((Math.floor(number * 100) / 100).toFixed(2))
        },
    },
    computed: {
        params() {
            return {
                enps_researches_ids: this.filters.enpsResearches,
                departments_ids: this.filters.departments,
            }
        },
        donutGraphicData() {
            return [this.report.detractors_percent, this.report.neutral_percent, this.report.promoters_percent]
        },
        barGraphicData() {
            return [
                {
                    data: [this.report.promoters_percent],
                },
                {
                    data: [this.report.neutral_percent],
                },
                {
                    data: [this.report.detractors_percent],
                },
            ]
        },
        barGraphicLabels() {
            return [
                [this.report.promoters_total.toFixed(0), i18n.t('enps.report.promoters')],
                [this.report.neutral_total.toFixed(0), i18n.t('enps.report.neutral')],
                [this.report.detractors_total.toFixed(0), i18n.t('enps.report.detractors')],
            ]
        },
    },
}
</script>

<style lang="scss" scoped>
.title {
    font-weight: bold;
    font-size: 40px;
    line-height: 47px;
    color: #022b4f;
}
.filters {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-bottom: 10px;
}
.dividing-line {
    border-left: 2px solid #bec0c0;
}
hr.top {
    margin-left: 32px;
    margin-right: 32px;
    border-top: 1px solid #bec0c0;
}
hr.bottom {
    margin-left: 32px;
    margin-right: 32px;
    border-bottom: 1px solid #bec0c0;
}
/deep/ .page-item.active .page-link {
    background-color: #022b4f;
    border-color: #022b4f;
}
</style>
